var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-tip-tap-editor',{ref:"editor",on:{"update":_vm.updateContent}}),_c('v-btn',{staticClass:"mt-4",attrs:{"outlined":"","color":"primary"},on:{"click":_vm.insertDefaultContent}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v("\n    Chèn nội dung mẫu\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }